"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var t = require("react");
var r = function r(t, _r, e) {
  return _r in t ? Object.defineProperty(t, _r, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[_r] = e, t;
};
var e = function e(t) {
  if (Array.isArray(t)) return t;
};
var n = function n(t, r) {
  if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) {
    var e = [],
      n = !0,
      o = !1,
      i = void 0;
    try {
      for (var a, c = t[Symbol.iterator](); !(n = (a = c.next()).done) && (e.push(a.value), !r || e.length !== r); n = !0) {
        ;
      }
    } catch (t) {
      o = !0, i = t;
    } finally {
      try {
        n || null == c.return || c.return();
      } finally {
        if (o) throw i;
      }
    }
    return e;
  }
};
var o = function o(t, r) {
  (null == r || r > t.length) && (r = t.length);
  for (var e = 0, n = new Array(r); e < r; e++) {
    n[e] = t[e];
  }
  return n;
};
var i = function i(t, r) {
  if (t) {
    if ("string" == typeof t) return o(t, r);
    var e = Object.prototype.toString.call(t).slice(8, -1);
    return "Object" === e && t.constructor && (e = t.constructor.name), "Map" === e || "Set" === e ? Array.from(t) : "Arguments" === e || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? o(t, r) : void 0;
  }
};
var a = function a() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
};
var c = function c(t, r) {
  return e(t) || n(t, r) || i(t, r) || a();
};
function u(t, r) {
  return t(r = {
    exports: {}
  }, r.exports), r.exports;
}
var f = u(function (t) {
  var r = function (t) {
    var r,
      e = Object.prototype,
      n = e.hasOwnProperty,
      o = "function" == typeof Symbol ? Symbol : {},
      i = o.iterator || "@@iterator",
      a = o.asyncIterator || "@@asyncIterator",
      c = o.toStringTag || "@@toStringTag";
    function u(t, r, e) {
      return Object.defineProperty(t, r, {
        value: e,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), t[r];
    }
    try {
      u({}, "");
    } catch (t) {
      u = function u(t, r, e) {
        return t[r] = e;
      };
    }
    function f(t, r, e, n) {
      var o = r && r.prototype instanceof v ? r : v,
        i = Object.create(o.prototype),
        a = new P(n || []);
      return i._invoke = function (t, r, e) {
        var n = l;
        return function (o, i) {
          if (n === p) throw new Error("Generator is already running");
          if (n === y) {
            if ("throw" === o) throw i;
            return _();
          }
          for (e.method = o, e.arg = i;;) {
            var a = e.delegate;
            if (a) {
              var c = I(a, e);
              if (c) {
                if (c === h) continue;
                return c;
              }
            }
            if ("next" === e.method) e.sent = e._sent = e.arg;else if ("throw" === e.method) {
              if (n === l) throw n = y, e.arg;
              e.dispatchException(e.arg);
            } else "return" === e.method && e.abrupt("return", e.arg);
            n = p;
            var u = s(t, r, e);
            if ("normal" === u.type) {
              if (n = e.done ? y : d, u.arg === h) continue;
              return {
                value: u.arg,
                done: e.done
              };
            }
            "throw" === u.type && (n = y, e.method = "throw", e.arg = u.arg);
          }
        };
      }(t, e, a), i;
    }
    function s(t, r, e) {
      try {
        return {
          type: "normal",
          arg: t.call(r, e)
        };
      } catch (t) {
        return {
          type: "throw",
          arg: t
        };
      }
    }
    t.wrap = f;
    var l = "suspendedStart",
      d = "suspendedYield",
      p = "executing",
      y = "completed",
      h = {};
    function v() {}
    function m() {}
    function b() {}
    var g = {};
    g[i] = function () {
      return this;
    };
    var O = Object.getPrototypeOf,
      j = O && O(O(D([])));
    j && j !== e && n.call(j, i) && (g = j);
    var w = b.prototype = v.prototype = Object.create(g);
    function S(t) {
      ["next", "throw", "return"].forEach(function (r) {
        u(t, r, function (t) {
          return this._invoke(r, t);
        });
      });
    }
    function x(t, r) {
      var e;
      this._invoke = function (o, i) {
        function a() {
          return new r(function (e, a) {
            !function e(o, i, a, c) {
              var u = s(t[o], t, i);
              if ("throw" !== u.type) {
                var f = u.arg,
                  l = f.value;
                return l && "object" == typeof l && n.call(l, "__await") ? r.resolve(l.__await).then(function (t) {
                  e("next", t, a, c);
                }, function (t) {
                  e("throw", t, a, c);
                }) : r.resolve(l).then(function (t) {
                  f.value = t, a(f);
                }, function (t) {
                  return e("throw", t, a, c);
                });
              }
              c(u.arg);
            }(o, i, e, a);
          });
        }
        return e = e ? e.then(a, a) : a();
      };
    }
    function I(t, e) {
      var n = t.iterator[e.method];
      if (n === r) {
        if (e.delegate = null, "throw" === e.method) {
          if (t.iterator.return && (e.method = "return", e.arg = r, I(t, e), "throw" === e.method)) return h;
          e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
        }
        return h;
      }
      var o = s(n, t.iterator, e.arg);
      if ("throw" === o.type) return e.method = "throw", e.arg = o.arg, e.delegate = null, h;
      var i = o.arg;
      return i ? i.done ? (e[t.resultName] = i.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = r), e.delegate = null, h) : i : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, h);
    }
    function E(t) {
      var r = {
        tryLoc: t[0]
      };
      1 in t && (r.catchLoc = t[1]), 2 in t && (r.finallyLoc = t[2], r.afterLoc = t[3]), this.tryEntries.push(r);
    }
    function F(t) {
      var r = t.completion || {};
      r.type = "normal", delete r.arg, t.completion = r;
    }
    function P(t) {
      this.tryEntries = [{
        tryLoc: "root"
      }], t.forEach(E, this), this.reset(!0);
    }
    function D(t) {
      if (t) {
        var e = t[i];
        if (e) return e.call(t);
        if ("function" == typeof t.next) return t;
        if (!isNaN(t.length)) {
          var o = -1,
            a = function e() {
              for (; ++o < t.length;) {
                if (n.call(t, o)) return e.value = t[o], e.done = !1, e;
              }
              return e.value = r, e.done = !0, e;
            };
          return a.next = a;
        }
      }
      return {
        next: _
      };
    }
    function _() {
      return {
        value: r,
        done: !0
      };
    }
    return m.prototype = w.constructor = b, b.constructor = m, m.displayName = u(b, c, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
      var r = "function" == typeof t && t.constructor;
      return !!r && (r === m || "GeneratorFunction" === (r.displayName || r.name));
    }, t.mark = function (t) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(t, b) : (t.__proto__ = b, u(t, c, "GeneratorFunction")), t.prototype = Object.create(w), t;
    }, t.awrap = function (t) {
      return {
        __await: t
      };
    }, S(x.prototype), x.prototype[a] = function () {
      return this;
    }, t.AsyncIterator = x, t.async = function (r, e, n, o, i) {
      void 0 === i && (i = Promise);
      var a = new x(f(r, e, n, o), i);
      return t.isGeneratorFunction(e) ? a : a.next().then(function (t) {
        return t.done ? t.value : a.next();
      });
    }, S(w), u(w, c, "Generator"), w[i] = function () {
      return this;
    }, w.toString = function () {
      return "[object Generator]";
    }, t.keys = function (t) {
      var r = [];
      for (var e in t) {
        r.push(e);
      }
      return r.reverse(), function e() {
        for (; r.length;) {
          var n = r.pop();
          if (n in t) return e.value = n, e.done = !1, e;
        }
        return e.done = !0, e;
      };
    }, t.values = D, P.prototype = {
      constructor: P,
      reset: function reset(t) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = r, this.done = !1, this.delegate = null, this.method = "next", this.arg = r, this.tryEntries.forEach(F), !t) for (var e in this) {
          "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = r);
        }
      },
      stop: function stop() {
        this.done = !0;
        var t = this.tryEntries[0].completion;
        if ("throw" === t.type) throw t.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(t) {
        if (this.done) throw t;
        var e = this;
        function o(n, o) {
          return c.type = "throw", c.arg = t, e.next = n, o && (e.method = "next", e.arg = r), !!o;
        }
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var a = this.tryEntries[i],
            c = a.completion;
          if ("root" === a.tryLoc) return o("end");
          if (a.tryLoc <= this.prev) {
            var u = n.call(a, "catchLoc"),
              f = n.call(a, "finallyLoc");
            if (u && f) {
              if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
              if (this.prev < a.finallyLoc) return o(a.finallyLoc);
            } else if (u) {
              if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
            } else {
              if (!f) throw new Error("try statement without catch or finally");
              if (this.prev < a.finallyLoc) return o(a.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(t, r) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var o = this.tryEntries[e];
          if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
            var i = o;
            break;
          }
        }
        i && ("break" === t || "continue" === t) && i.tryLoc <= r && r <= i.finallyLoc && (i = null);
        var a = i ? i.completion : {};
        return a.type = t, a.arg = r, i ? (this.method = "next", this.next = i.finallyLoc, h) : this.complete(a);
      },
      complete: function complete(t, r) {
        if ("throw" === t.type) throw t.arg;
        return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), h;
      },
      finish: function finish(t) {
        for (var r = this.tryEntries.length - 1; r >= 0; --r) {
          var e = this.tryEntries[r];
          if (e.finallyLoc === t) return this.complete(e.completion, e.afterLoc), F(e), h;
        }
      },
      catch: function _catch(t) {
        for (var r = this.tryEntries.length - 1; r >= 0; --r) {
          var e = this.tryEntries[r];
          if (e.tryLoc === t) {
            var n = e.completion;
            if ("throw" === n.type) {
              var o = n.arg;
              F(e);
            }
            return o;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(t, e, n) {
        return this.delegate = {
          iterator: D(t),
          resultName: e,
          nextLoc: n
        }, "next" === this.method && (this.arg = r), h;
      }
    }, t;
  }(t.exports);
  try {
    regeneratorRuntime = r;
  } catch (t) {
    Function("r", "regeneratorRuntime = r")(r);
  }
});
function s(t, r, e, n, o, i, a) {
  try {
    var c = t[i](a),
      u = c.value;
  } catch (t) {
    return void e(t);
  }
  c.done ? r(u) : Promise.resolve(u).then(n, o);
}
var l = function l(t) {
  return function () {
    var r = this,
      e = arguments;
    return new Promise(function (n, o) {
      var i = t.apply(r, e);
      function a(t) {
        s(i, n, o, a, c, "next", t);
      }
      function c(t) {
        s(i, n, o, a, c, "throw", t);
      }
      a(void 0);
    });
  };
};
var d = h;
function p(t) {
  return t && t.constructor && "function" == typeof t.constructor.isBuffer && t.constructor.isBuffer(t);
}
function y(t) {
  return t;
}
function h(t, r) {
  var e = (r = r || {}).delimiter || ".",
    n = r.maxDepth,
    o = r.transformKey || y,
    i = {};
  return function t(a, c, u) {
    u = u || 1, Object.keys(a).forEach(function (f) {
      var s = a[f],
        l = r.safe && Array.isArray(s),
        d = Object.prototype.toString.call(s),
        y = p(s),
        h = "[object Object]" === d || "[object Array]" === d,
        v = c ? c + e + o(f) : o(f);
      if (!l && !y && h && Object.keys(s).length && (!r.maxDepth || u < n)) return t(s, v, u + 1);
      i[v] = s;
    });
  }(t), i;
}
h.flatten = h, h.unflatten = function t(r, e) {
  var n = (e = e || {}).delimiter || ".",
    o = e.overwrite || !1,
    i = e.transformKey || y,
    a = {};
  if (p(r) || "[object Object]" !== Object.prototype.toString.call(r)) return r;
  function c(t) {
    var r = Number(t);
    return isNaN(r) || -1 !== t.indexOf(".") || e.object ? t : r;
  }
  return r = Object.keys(r).reduce(function (t, o) {
    var i = Object.prototype.toString.call(r[o]);
    return !("[object Object]" === i || "[object Array]" === i) || function (t) {
      var r = Object.prototype.toString.call(t),
        e = "[object Array]" === r,
        n = "[object Object]" === r;
      if (!t) return !0;
      if (e) return !t.length;
      if (n) return !Object.keys(t).length;
    }(r[o]) ? (t[o] = r[o], t) : function (t, r, e) {
      return Object.keys(e).reduce(function (r, o) {
        return r[t + n + o] = e[o], r;
      }, r);
    }(o, t, h(r[o], e));
  }, {}), Object.keys(r).forEach(function (u) {
    var f = u.split(n).map(i);
    var s = c(f.shift()),
      l = c(f[0]),
      d = a;
    for (; void 0 !== l;) {
      if ("__proto__" === s) return;
      var _t2 = Object.prototype.toString.call(d[s]),
        _r2 = "[object Object]" === _t2 || "[object Array]" === _t2;
      if (!o && !_r2 && void 0 !== d[s]) return;
      (o && !_r2 || !o && null == d[s]) && (d[s] = "number" != typeof l || e.object ? {} : []), d = d[s], f.length > 0 && (s = c(f.shift()), l = c(f[0]));
    }
    d[s] = t(r[u], e);
  }), a;
};
var v = u(function (t) {
  function r(e) {
    return "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? t.exports = r = function r(t) {
      return typeof t;
    } : t.exports = r = function r(t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, r(e);
  }
  t.exports = r;
});
var m = function m(t, r) {
    if (!(t instanceof r)) throw new TypeError("Cannot call a class as a function");
  },
  b = u(function (t) {
    function r(e, n) {
      return t.exports = r = Object.setPrototypeOf || function (t, r) {
        return t.__proto__ = r, t;
      }, r(e, n);
    }
    t.exports = r;
  });
var g = function g(t, r) {
  if ("function" != typeof r && null !== r) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(r && r.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), r && b(t, r);
};
var O = function O(t) {
  if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
};
var j = function j(t, r) {
    return !r || "object" !== v(r) && "function" != typeof r ? O(t) : r;
  },
  w = u(function (t) {
    function r(e) {
      return t.exports = r = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, r(e);
    }
    t.exports = r;
  });
var S = function S(t) {
  return -1 !== Function.toString.call(t).indexOf("[native code]");
};
var x = function x() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
    } catch (t) {
      return !1;
    }
  },
  I = u(function (t) {
    function r(e, n, o) {
      return x() ? t.exports = r = Reflect.construct : t.exports = r = function r(t, _r3, e) {
        var n = [null];
        n.push.apply(n, _r3);
        var o = new (Function.bind.apply(t, n))();
        return e && b(o, e.prototype), o;
      }, r.apply(null, arguments);
    }
    t.exports = r;
  });
function E(t) {
  var r = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
    } catch (t) {
      return !1;
    }
  }();
  return function () {
    var e,
      n = w(t);
    if (r) {
      var o = w(this).constructor;
      e = Reflect.construct(n, arguments, o);
    } else e = n.apply(this, arguments);
    return j(this, e);
  };
}
var F = function (t) {
    function r(t) {
      var n;
      return m(this, r), (n = e.call(this, t)).name = "ParamValidationError", n;
    }
    g(r, t);
    var e = E(r);
    return r;
  }(u(function (t) {
    function r(e) {
      var n = "function" == typeof Map ? new Map() : void 0;
      return t.exports = r = function r(t) {
        if (null === t || !S(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== n) {
          if (n.has(t)) return n.get(t);
          n.set(t, r);
        }
        function r() {
          return I(t, arguments, w(this).constructor);
        }
        return r.prototype = Object.create(t.prototype, {
          constructor: {
            value: r,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), b(r, t);
      }, r(e);
    }
    t.exports = r;
  })(Error)),
  P = {
    FUNCTION: v(function () {}),
    NUMBER: v(1),
    BOOLEAN: v(!0),
    STRING: v("string"),
    OBJECT: v({})
  },
  D = function D(t, r) {
    var e = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : "UNDEFINED_FIELD",
      n = !(3 < arguments.length && void 0 !== arguments[3]) || arguments[3];
    if (r && void 0 === P[r.toUpperCase()]) throw new F("Invalid field ".concat(e, " type, ").concat(r, " is invalid ").concat(v(t), ". ").concat(e, " is a ").concat(n ? "required" : "not required", " parameter"));
    if (v(t) !== r && (n || void 0 !== t && !n)) throw new F("Invalid ".concat(e, " param, expected ").concat(r, " and received ").concat(v(t), ". ").concat(e, " is a ").concat(n ? "required" : "not required", " parameter"));
  },
  _ = function _(t, r, e) {
    return D(t, P.BOOLEAN, r, e);
  },
  T = function T(t, r, e) {
    return D(t, P.STRING, r, e);
  },
  k = function k(t, r, e) {
    return D(t, P.FUNCTION, r, e);
  },
  A = function A(t, r, e) {
    return D(t, P.OBJECT, r, e);
  },
  L = function L(t, r, e) {
    return D(t, P.NUMBER, r, e);
  },
  R = {
    isBoolean: function isBoolean() {
      for (var t = arguments.length, r = Array(t), e = 0; e < t; e++) {
        r[e] = arguments[e];
      }
      return _.apply(void 0, r.concat([!1]));
    },
    isString: function isString() {
      for (var t = arguments.length, r = Array(t), e = 0; e < t; e++) {
        r[e] = arguments[e];
      }
      return T.apply(void 0, r.concat([!1]));
    },
    isFunction: function isFunction() {
      for (var t = arguments.length, r = Array(t), e = 0; e < t; e++) {
        r[e] = arguments[e];
      }
      return k.apply(void 0, r.concat([!1]));
    },
    isObject: function isObject() {
      for (var t = arguments.length, r = Array(t), e = 0; e < t; e++) {
        r[e] = arguments[e];
      }
      return A.apply(void 0, r.concat([!1]));
    },
    isNumber: function isNumber() {
      for (var t = arguments.length, r = Array(t), e = 0; e < t; e++) {
        r[e] = arguments[e];
      }
      return L.apply(void 0, r.concat([!1]));
    }
  },
  M = T,
  N = k,
  C = A,
  V = d.unflatten,
  z = function z(t, r) {
    if (C(t, "object"), R.isObject(r, "fieldsFlatMap"), !r) return d(t);
    var e = d(t);
    return Object.entries(e).reduce(function (t, e) {
      var n = c(e, 2),
        o = n[0],
        i = n[1];
      return !t[o] && r[o] && (t[o] = i), t;
    }, {});
  },
  B = {},
  G = function G(t, r) {
    if (B[t]) throw new Error("the form ".concat(t, " is already registered, please choose a different name"));
    B[t] = r;
  },
  U = function U(t) {
    return B[t];
  };
function Y(t, r) {
  if (t.length !== r.length) return !1;
  for (var e = 0; e < t.length; e++) {
    if (t[e] !== r[e]) return !1;
  }
  return !0;
}
function q() {
  var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
    r = 1 < arguments.length ? arguments[1] : void 0,
    e = 2 < arguments.length ? arguments[2] : void 0;
  return (t = t[(r = Array.isArray(r) ? r : r.split("."))[0]]) && 1 < r.length ? q(t, r.slice(1)) : void 0 === t ? e : t;
}
function J(t, r) {
  var e = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    r && (n = n.filter(function (r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), e.push.apply(e, n);
  }
  return e;
}
function K(t) {
  for (var e, n = 1; n < arguments.length; n++) {
    e = null == arguments[n] ? {} : arguments[n], n % 2 ? J(Object(e), !0).forEach(function (n) {
      r(t, n, e[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : J(Object(e)).forEach(function (r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(e, r));
    });
  }
  return t;
}
var Z = function Z() {
    var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
      r = !!(1 < arguments.length && void 0 !== arguments[1]) && arguments[1],
      e = K(K({}, t.initialData || {}), t.data || {});
    return e && V(Object.keys(e).reduce(function (n, o) {
      var i = !!t.dirtyFields && !!t.dirtyFields[o],
        a = t.errors && t.errors[o],
        c = t.isSubmitted;
      if (!r) return n[o] = {
        value: e[o],
        isPristine: !i,
        isTouched: i,
        isSubmitted: c,
        isInitialized: t.isInitialized,
        error: a,
        isValid: !t.errors || !a,
        isInvalid: !!t.errors && !!a,
        showError: (i || c) && !!a,
        path: o
      }, n;
      var u = q(t.fields, o) || {};
      return u.value = e[o], n[o] = u, n;
    }, {}));
  },
  $ = "".concat("MY-FORM-STATE", "/VALIDATED_FORM"),
  H = "".concat("MY-FORM-STATE", "/UPDATE_FORM"),
  Q = "".concat("MY-FORM-STATE", "/SUBMIT_FORM"),
  W = "".concat("MY-FORM-STATE", "/CLEAR_FORM"),
  X = "".concat("MY-FORM-STATE", "/INITIALIZE_FORM"),
  tt = "".concat("MY-FORM-STATE", "/RESET_FORM");
function rt(t, r) {
  var e = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    r && (n = n.filter(function (r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), e.push.apply(e, n);
  }
  return e;
}
function et(t) {
  for (var e, n = 1; n < arguments.length; n++) {
    e = null == arguments[n] ? {} : arguments[n], n % 2 ? rt(Object(e), !0).forEach(function (n) {
      r(t, n, e[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : rt(Object(e)).forEach(function (r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(e, r));
    });
  }
  return t;
}
var nt = function nt() {
    var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
      r = 1 < arguments.length ? arguments[1] : void 0;
    switch (r.type) {
      case $:
        var e = r.payload && 0 < Object.keys(r.payload).length || !1,
          n = et(et({}, t), {}, {
            errors: z(r.payload),
            isInvalid: e,
            isValid: !e,
            isSubmittable: !!t.isTouched && !e
          });
        return n.fields = Z(n), n;
      case H:
        if (r.payload) {
          var o = z(r.payload),
            i = et(et({}, t), {}, {
              isPristine: !1,
              isTouched: !0,
              isSubmitted: !1,
              isSubmittable: !!t.isTouched && !!t.isValid,
              dirtyFields: t.dirtyFields || {}
            });
          return Object.assign(i.dirtyFields, Object.keys(o).reduce(function (t, r) {
            return t[r] = !0, t;
          }, {})), Object.assign(t.data, o), i.fields = Z(i, !0), i;
        }
        return t;
      case X:
      case tt:
        var a = {
          data: {},
          initialData: r.payload ? z(r.payload) : {},
          isPristine: !0,
          isInitialized: !0,
          isSubmitted: !1,
          isSubmittable: !1,
          isTouched: !1,
          errors: {},
          dirtyFields: {},
          isInvalid: void 0,
          isValid: void 0
        };
        return a.fields = Z(a, !0), a;
      case Q:
        var c = et(et({}, t), {}, {
          resultData: V(et(et({}, t.initialData), t.data)),
          isSubmitted: !0
        });
        return c.fields = Z(c), c;
      case W:
        return;
      default:
        return t;
    }
  },
  ot = function ot(t, r) {
    var e = r.formId;
    M(e, "formId"), C(t, "state");
    var n = t && t["my-react-form-state"];
    if (!n) throw new Error("`my-react-form-state` reducer has not been initialized yet. Please run first `initializeReducer` from `my-react-form-state/redux`");
    return n && n[e] || {};
  },
  it = function (t) {
    function r() {
      for (var r = [], c = 0; c < arguments.length; c++) {
        r[c] = 0 > c || arguments.length <= c ? void 0 : arguments[c];
      }
      return a && e === this && o(r, i) || (n = t.apply(this, r), a = !0, e = this, i = r), n;
    }
    var e,
      n,
      o = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : Y,
      i = [],
      a = !1;
    return r;
  }(function (t, r) {
    var e = U(t),
      n = e.initialFields,
      o = e.initialState;
    return {
      data: r.data || {},
      initialData: r.initialData || o,
      resultData: r.resultData,
      isSubmitted: r.isSubmitted,
      isSubmittable: r.isSubmittable,
      isInitialized: r.isInitialized,
      isTouched: r.isTouched,
      isPristine: r.isPristine,
      errors: r.errors || {},
      isValid: r.isValid,
      isInvalid: r.isInvalid,
      dirtyFields: r.dirtyFields || {},
      fields: r.fields || n || {}
    };
  }),
  at = function at(t, r) {
    var e = r.formId;
    M(e, "formId"), C(t, "state");
    var n = ot(t, {
      formId: e
    }) || {};
    return n && n.resultData;
  },
  ct = Object.freeze({
    __proto__: null,
    getFormIdState: ot,
    getForm: function getForm(t, r) {
      var e = r.formId;
      M(e, "formId"), C(t, "state");
      var n = ot(t, {
        formId: e
      }) || {};
      return it(e, n);
    },
    getFormResult: at
  }),
  ut = function ut(t) {
    var r = t.errors,
      e = t.formId;
    return {
      type: $,
      payload: "object" === v(r) ? r : {},
      options: {
        formId: e
      }
    };
  },
  ft = function ft(t) {
    var r = t.formId;
    return {
      type: Q,
      options: {
        formId: r
      }
    };
  },
  st = function st(t) {
    var r = t.formId;
    return {
      type: W,
      options: {
        formId: r
      }
    };
  };
function lt(t, r) {
  var e = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    r && (n = n.filter(function (r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), e.push.apply(e, n);
  }
  return e;
}
function dt(t) {
  for (var e, n = 1; n < arguments.length; n++) {
    e = null == arguments[n] ? {} : arguments[n], n % 2 ? lt(Object(e), !0).forEach(function (n) {
      r(t, n, e[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : lt(Object(e)).forEach(function (r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(e, r));
    });
  }
  return t;
}
var pt,
  yt,
  ht,
  vt,
  mt = function mt(t) {
    var r = t.formId;
    return function () {
      var t = l(f.mark(function t(e, n) {
        var o, i, a, c;
        return f.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (M(r, "formId"), N(e, "dispatch"), N(n, "getState"), o = U(r), i = o.formValidator) {
                  t.next = 8;
                  break;
                }
                return e(ut({
                  errors: void 0,
                  formId: r
                })), t.abrupt("return", !0);
              case 8:
                return a = ot(n(), {
                  formId: r
                }), t.next = 11, i(V(dt(dt({}, a.initialData), a.data)));
              case 11:
                if (!(c = t.sent)) {
                  t.next = 15;
                  break;
                }
                return e(ut({
                  errors: c,
                  formId: r
                })), t.abrupt("return", !1);
              case 15:
                return e(ut({
                  errors: void 0,
                  formId: r
                })), t.abrupt("return", !0);
              case 17:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }));
      return function () {
        return t.apply(this, arguments);
      };
    }();
  },
  bt = (pt = function pt(t, r) {
    r(mt({
      formId: t
    }));
  }, yt = 100, ht = !1, function () {
    var t = this,
      r = arguments,
      e = ht && !vt;
    clearTimeout(vt), vt = setTimeout(function () {
      vt = null, ht || pt.apply(t, r);
    }, yt), e && pt.apply(t, r);
  }),
  gt = function gt(t) {
    var r = t.formId,
      e = t.data;
    return function (t) {
      M(r, "formId"), C(e, "data"), N(t, "dispatch"), t(function (t) {
        var r = t.data,
          e = t.formId;
        return {
          type: H,
          payload: r,
          options: {
            formId: e
          }
        };
      }({
        data: e,
        formId: r
      })), bt(r, t);
    };
  },
  Ot = Object.freeze({
    __proto__: null,
    updateField: function updateField(t) {
      var e = t.formId,
        n = t.field,
        o = t.value;
      return function (t) {
        M(e, "formId"), M(n, "field"), N(t, "dispatch"), t(gt({
          formId: e,
          data: r({}, n, o)
        }));
      };
    },
    updateForm: gt,
    submitForm: function submitForm(t) {
      var r = t.formId;
      return function () {
        var t = l(f.mark(function t(e, n) {
          return f.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return M(r, "formId"), N(e, "dispatch"), e(ft({
                    formId: r
                  })), t.next = 5, e(mt({
                    formId: r
                  }));
                case 5:
                  return t.abrupt("return", at(n(), {
                    formId: r
                  }));
                case 6:
                case "end":
                  return t.stop();
              }
            }
          }, t);
        }));
        return function () {
          return t.apply(this, arguments);
        };
      }();
    },
    initializeForm: function initializeForm(t) {
      var r = t.formId,
        e = t.initialState,
        n = void 0 === e ? {} : e;
      return function (t) {
        M(r, "formId"), C(n, "initialState"), N(t, "dispatch");
        var e = U(r).fieldsDefinition;
        return t(function (t) {
          var r = t.initialState,
            e = t.formId,
            n = t.fieldsDefinition;
          return {
            type: X,
            payload: r,
            options: {
              formId: e,
              fieldsDefinition: n
            }
          };
        }({
          initialState: n,
          formId: r,
          fieldsDefinition: e
        })), t(mt({
          formId: r
        }));
      };
    },
    removeForm: function removeForm(t) {
      var r = t.formId;
      return function (t) {
        return M(r, "formId"), N(t, "dispatch"), t(st({
          formId: r
        }));
      };
    },
    resetForm: function resetForm(t) {
      var r = t.formId,
        e = t.initialState;
      return function (t) {
        M(r, "formId"), R.isObject(e, "initialState"), N(t, "dispatch");
        var n = U(r);
        t(st({
          formId: r
        })), t(function (t) {
          var r = t.formId,
            e = t.initialState,
            n = t.fieldsDefinition;
          return {
            type: tt,
            payload: e,
            options: {
              formId: r,
              fieldsDefinition: n
            }
          };
        }({
          formId: r,
          initialState: e || n.initialState,
          fieldsDefinition: n.fieldsDefinition
        }));
      };
    }
  }),
  jt = function jt() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (t) {
      var r = 0 | 16 * Math.random();
      return ("x" === t ? r : 8 | 3 & r).toString(16);
    });
  },
  wt = function wt(t) {
    var r = t.jsonSchema;
    C(r, "jsonSchema");
    var e = d(r);
    return Object.entries(e).reduce(function (t, r) {
      var e = c(r, 2),
        n = e[0],
        o = e[1];
      return "type" === n || "type" === n || "object" === o || -1 !== n.indexOf("required") || (t[n.replace(/properties./g, "").replace(/.type/g, "").replace(/.items/g, "").replace(/.enum/g, "").replace(/.additionalItems/g, "")] = o), t;
    }, {});
  };
function St(t, r) {
  var e = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    r && (n = n.filter(function (r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), e.push.apply(e, n);
  }
  return e;
}
function xt(t) {
  for (var e, n = 1; n < arguments.length; n++) {
    e = null == arguments[n] ? {} : arguments[n], n % 2 ? St(Object(e), !0).forEach(function (n) {
      r(t, n, e[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : St(Object(e)).forEach(function (r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(e, r));
    });
  }
  return t;
}
var It = {
    string: "",
    number: 0,
    boolean: !1,
    date: null,
    array: [],
    object: []
  },
  Et = function Et(t, r) {
    return Object.keys(t).reduce(function (e, n) {
      return e[n] = function () {
        var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
        return t[n](xt(xt({}, r), e));
      }, e;
    }, {});
  },
  Ft = function Ft(t, r) {
    return Object.keys(t).reduce(function (e, n) {
      return e[n] = function (e) {
        return t[n](e, xt({}, r));
      }, e;
    }, {});
  },
  Pt = function Pt(t, r) {
    if (!r) return xt({}, t);
    var e = Object.entries(r).reduce(function (t, r) {
      var e = c(r, 2),
        n = e[0],
        o = e[1];
      return t[n] = void 0 === It[o] ? null : It[o], t;
    }, {});
    return V(xt(xt({}, e), z(t, r)));
  },
  Dt = function Dt(t) {
    var r = t.formId;
    M(r, "formId"), function (t) {
      delete B[t];
    }(r);
  },
  _t = function _t() {
    var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
      e = 1 < arguments.length ? arguments[1] : void 0,
      n = e && e.options && e.options.formId;
    if (!n) return t;
    var o = t["my-react-form-state"][n],
      i = nt(o, e);
    if (void 0 === i) return delete t[n], t;
    var a = i === o ? t : r({}, "my-react-form-state", r({}, n, i));
    return a;
  };
exports.useMyFormState = function (e) {
  var n = e.formId,
    o = e.formValidator,
    i = e.formSchema,
    a = e.initialState,
    u = e.onFormChange,
    f = void 0 === u ? function () {} : u,
    s = t.useMemo(function () {
      return function () {
        var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {
            formId: jt(),
            initialState: {}
          },
          r = t.formId,
          e = void 0 === r ? jt() : r,
          n = t.formValidator,
          o = t.formSchema,
          i = t.initialState,
          a = void 0 === i ? {} : i;
        if (M(e, "formId"), R.isObject(a, "initialState"), R.isFunction(n, "formValidator"), R.isFunction(o, "formSchema"), !a && !o) throw Error("initialState and formSchema cannot be empty at the same time.");
        var u = "function" == typeof o ? o() : {
          jsonSchema: o
        };
        u.jsonSchema && (u.fieldsDefinition = wt({
          jsonSchema: u.jsonSchema
        })), n && (u.formValidator = n);
        var f = Object.freeze(Pt(a, u.fieldsDefinition));
        return G(e, xt(xt({}, u), {}, {
          initialState: f,
          initialFields: V(Object.entries(z(f)).reduce(function (t, r) {
            var e = c(r, 2),
              n = e[0],
              o = e[1];
            return t[n] = {
              value: o
            }, t;
          }, {}))
        })), {
          operations: Et(Ot, {
            formId: e
          }),
          selectors: Ft(ct, {
            formId: e
          }),
          formId: e,
          initialFormState: f,
          unregister: function unregister() {
            return Dt({
              formId: e
            });
          }
        };
      }({
        formId: n,
        formValidator: o,
        initialState: a,
        formSchema: i
      });
    }, []),
    l = s.operations,
    d = s.selectors.getForm,
    p = s.unregister,
    y = s.initialFormState,
    h = function (r, e) {
      var n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : function (t) {
          return t;
        },
        o = t.useState(n(e)),
        i = c(o, 2),
        a = i[0],
        u = i[1],
        f = t.useRef(a),
        s = t.useCallback(function () {
          return f.current;
        }, [f]),
        l = t.useCallback(function (t) {
          f.current = t, u(t);
        }, [f, u]),
        d = t.useCallback(function (t) {
          return r(s(), t);
        }, [r, s]),
        p = t.useCallback(function (t) {
          return "function" == typeof t ? t(p, s) : l(d(t));
        }, [s, l, d]);
      return [a, p];
    }(_t, r({}, "my-react-form-state", {})),
    v = c(h, 2),
    m = v[0],
    b = v[1];
  t.useEffect(function () {
    return b(l.initializeForm({
      initialState: y
    })), function () {
      p(), b(l.removeForm({
        dispatch: b,
        state: m
      }));
    };
  }, []);
  var g = t.useCallback(function (t) {
      return b(l.resetForm({
        initialState: t.initialState
      }));
    }, [l.resetForm]),
    O = t.useCallback(function (t) {
      var r = t.data;
      return b(l.updateForm({
        data: r
      }));
    }, [l.updateForm]),
    j = t.useCallback(function () {
      return b(l.submitForm());
    }, [l.submitForm]),
    w = t.useCallback(function (t) {
      var r = t.field,
        e = t.value;
      return b(l.updateField({
        field: r,
        value: e
      }));
    }, [l.updateField]),
    S = d(m);
  return t.useEffect(function () {
    f(S);
  }, [S]), [S, {
    resetForm: g,
    updateForm: O,
    updateField: w,
    submitForm: j
  }];
};